export class MPAResourceSelector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelectionMode",
            "baseName": "resourceSelectionMode",
            "type": "MPAResourceSelectionMode",
            "format": ""
        },
        {
            "name": "resourceInclusionOverride",
            "baseName": "resourceInclusionOverride",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceExclusionOverride",
            "baseName": "resourceExclusionOverride",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
